let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1eWDI")).then(() => parcelRequire('8CnfC'));